import React from 'react';
import PropTypes from 'prop-types';
import {
  Text,
  View,
  // Image,
} from 'react-native';
import styles from '../styles/index';
import { ViewPropTypes } from 'deprecated-react-native-prop-types'
// import info from '../assets/images/glyphicons-info-sign.png';

function InfoBlock(props) {
  const { style, children } = props;

  return (
    <View style={[styles.common.info, style]}>
      {/* <Image style={{ margin: 16 }} source={info} /> */}
      <Text
        style={styles.common.infoParagraph}
        ellipsizeMode="tail"
      >
        {children}
      </Text>
    </View>
  );
}

InfoBlock.defaultProps = {
  style: {},
  children: {},
};

InfoBlock.propTypes = {
  style: ViewPropTypes.style,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default InfoBlock;
